import React, { Component } from 'react';
import classnames from 'classnames';
import { reduxForm, Field } from 'redux-form';

import renderInputField from 'shared/forms/RenderInputField';
import Button from 'shared/components/Button';
import styles from './styles.module.scss';

class GlobalSearchInput extends Component {
  submit = data => {
    this.props.submitAction(data);
  };
  render() {
    const {
      handleSubmit,
      isNav,
      shouldAutoFocus = true,
      pristine,
      invalid
    } = this.props;

    return (
      <form className={styles.form} onSubmit={handleSubmit(this.submit)}>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <Field
              className={isNav ? styles.inputField : styles.pageInput}
              component={renderInputField}
              name="search"
              autoFocus={shouldAutoFocus}
              placeholder="Search Unissu"
              autoComplete="off"
              id="global-search-input"
              required
            />
          </div>
          {isNav ? (
            <button
              className={styles.searchBtn}
              type="submit"
              disabled={pristine || invalid}>
              <i className={classnames(styles.icon, 'material-icons')}>
                search
              </i>
            </button>
          ) : (
            <Button
              color="primary"
              className={styles.submitBtn}
              type="submit"
              disabled={pristine || invalid}>
              <div className="remove-xs">Search</div>
              <i className={classnames('material-icons', 'remove-sm-min')}>
                search
              </i>
            </Button>
          )}
        </div>
      </form>
    );
  }
}

GlobalSearchInput = reduxForm({
  form: 'GlobalSearch',
  enableReinitialize: false,
  destroyOnUnmount: false
})(GlobalSearchInput);

export default GlobalSearchInput;
